import { render, staticRenderFns } from "./serve-new.vue?vue&type=template&id=ce443c3e&scoped=true&"
import script from "./serve-new.vue?vue&type=script&lang=js&"
export * from "./serve-new.vue?vue&type=script&lang=js&"
import style0 from "./serve-new.vue?vue&type=style&index=0&id=ce443c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce443c3e",
  null
  
)

export default component.exports